

import { Smartphone, User, BellOff } from "lucide-react";

const HowItWorksSection = () => {
  const steps = [
    {
      icon: User,
      title: "1. Sie richten es ein",
      description: "Name und Handynummer Ihrer Mutter oder Ihres Vaters, dazu Ihre eigene Nummer. Drei Minuten, kein Gerät, keine App. Ihr Angehöriger bekommt von uns eine Nachricht, die erklärt, worum es geht."
    },
    {
      icon: Smartphone,
      title: "2. Wir fragen jeden Morgen nach",
      description: "Um 8 Uhr geht eine kurze, freundliche Nachricht raus – per SMS oder WhatsApp, auf das Handy, das ohnehin schon da ist. Ein Wort als Antwort genügt."
    },
    {
      icon: BellOff,
      title: "3. Sie hören nichts – und das ist gut so",
      description: "Kommt die Antwort, passiert nichts. Wir melden uns bei Ihnen nur, wenn keine Antwort kommt. Keine Nachricht von uns heisst: alles in Ordnung."
    }
  ];

  return (
  <>
  <a name="how-it-works"></a>
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">
          So einfach funktioniert es
        </h2>

        <p className="text-lg text-gray-600 text-center max-w-2xl mx-auto -mt-10 mb-16">
          Für Sie als Angehörige – und genauso, wenn Sie es für sich selbst einrichten.
        </p>
        
        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="text-center">
                <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <IconComponent className="w-10 h-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
        
        <div className="text-center mt-16">
          <div className="bg-green-50 border border-green-200 rounded-lg p-6 max-w-2xl mx-auto">
            <p className="text-lg text-green-800">
              <strong>Wichtig:</strong> Sie können jederzeit antworten – wann Sie möchten. 
              Die Nachricht geht jeden Morgen um 8 Uhr raus. Nur wenn bis 12 Uhr keine Antwort da ist, wird Ihre Kontaktperson (Angehörige/r, Betreuungsperson etc.) informiert.<br/>Bitte beachten Sie, dass dies kein Notrufdienst ist.
            </p>
          </div>
        </div>
      </div>
    </section></>
  );
};

export default HowItWorksSection;
